import { NewCoursePage } from './NewCoursePage';

export default NewCoursePage;
